(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["papaprints-banner-slider"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    function initSlider(root) {
      if (!root || root.dataset.ppInit === 'true') return;
      var track = root.querySelector('.pp-bslider__track');
      if (!track) return;
      var NOT_SLIDES = { STYLE: 1, SCRIPT: 1, TEMPLATE: 1, LINK: 1 };
      var slides = Array.prototype.slice.call(track.children).filter(function (el) {
        return !NOT_SLIDES[el.tagName];
      });
      if (slides.length < 2) return;
      root.dataset.ppInit = 'true';

      var dotsWrap = root.querySelector('.pp-bslider__dots');
      var prev = root.querySelector('.pp-bslider__arrow--prev');
      var next = root.querySelector('.pp-bslider__arrow--next');
      var autoplay = root.getAttribute('data-autoplay') === 'true';
      var delay = parseInt(root.getAttribute('data-delay'), 10) || 7000;
      var current = 0;
      var timer = null;
      var dots = [];
      var animating = false; // true while a programmatic scroll animation is in flight
      var raf = null;
      var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      // Native smooth scrollTo() is unreliable inside a mandatory scroll-snap
      // container, so animate scrollLeft ourselves and pause snapping meanwhile.
      function animateTo(target) {
        if (raf) cancelAnimationFrame(raf);
        var start = track.scrollLeft;
        var dist = target - start;
        var dur = reduceMotion ? 0 : 550;
        var t0 = performance.now();
        animating = true;
        track.style.scrollSnapType = 'none';
        function finish() {
          track.scrollLeft = target;
          track.style.scrollSnapType = '';
          animating = false;
          raf = null;
        }
        if (dur === 0 || Math.abs(dist) < 1) { finish(); return; }
        function frame(now) {
          var p = Math.min(1, (now - t0) / dur);
          var e = 1 - Math.pow(1 - p, 3); // ease-out cubic
          track.scrollLeft = start + dist * e;
          if (p < 1) raf = requestAnimationFrame(frame); else finish();
        }
        raf = requestAnimationFrame(frame);
      }

      if (dotsWrap) {
        dotsWrap.innerHTML = '';
        slides.forEach(function (_, i) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'pp-bslider__dot';
          b.setAttribute('role', 'tab');
          b.setAttribute('aria-label', 'Go to slide ' + (i + 1));
          b.setAttribute('aria-selected', i === 0 ? 'true' : 'false');
          b.addEventListener('click', function () { goTo(i, true); });
          dotsWrap.appendChild(b);
          dots.push(b);
        });
      }

      function setActive(i) {
        current = i;
        dots.forEach(function (d, j) { d.setAttribute('aria-selected', j === i ? 'true' : 'false'); });
      }

      function goTo(i, userAction) {
        var n = slides.length;
        i = ((i % n) + n) % n;
        setActive(i);
        animateTo(i * track.clientWidth);
        if (userAction) restart();
      }

      // Keep the current slide in place when the viewport is resized.
      var resizeRaf = null;
      window.addEventListener('resize', function () {
        if (resizeRaf) return;
        resizeRaf = requestAnimationFrame(function () {
          resizeRaf = null;
          if (!animating) track.scrollLeft = current * track.clientWidth;
        });
      });

      // Keep the active dot in sync with manual swipes / scroll-snap.
      var scrollRaf = null;
      track.addEventListener('scroll', function () {
        if (scrollRaf) return;
        scrollRaf = requestAnimationFrame(function () {
          scrollRaf = null;
          if (animating) return;
          var w = track.clientWidth || 1;
          var i = Math.round(track.scrollLeft / w);
          if (i !== current && i >= 0 && i < slides.length) setActive(i);
        });
      });

      if (prev) prev.addEventListener('click', function () { goTo(current - 1, true); });
      if (next) next.addEventListener('click', function () { goTo(current + 1, true); });

      function stop() { if (timer) { clearInterval(timer); timer = null; } }
      function start() {
        if (!autoplay || timer) return;
        timer = setInterval(function () { goTo(current + 1, false); }, delay);
      }
      function restart() { stop(); start(); }

      root.addEventListener('mouseenter', stop);
      root.addEventListener('mouseleave', start);
      root.addEventListener('focusin', stop);
      root.addEventListener('focusout', start);
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) stop(); else start();
      });
      start();

      // Theme editor: show the block being edited.
      root.addEventListener('pp:show-block', function (e) {
        var idx = slides.indexOf(e.detail);
        if (idx > -1) { stop(); goTo(idx, false); }
      });
    }

    function initAll(scope) {
      (scope || document).querySelectorAll('.pp-bslider').forEach(initSlider);
    }

    initAll();

    if (window.Shopify && Shopify.designMode) {
      document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
      document.addEventListener('shopify:block:select', function (e) {
        var root = e.target.closest('.pp-bslider');
        if (root) root.dispatchEvent(new CustomEvent('pp:show-block', { detail: e.target }));
      });
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
